import type { ReactNode } from 'react';
import { Link } from 'react-router';

/** LEG-05: the operator and contact every public page names. */
export const OPERATOR = 'ZorbitAI';
export const SUPPORT_EMAIL = 'support@zorbitai.com';
export const SITE_URL = 'https://zorbitai.com';

export function PublicNav() {
  return (
    <nav className="landing-nav">
      <Link to="/" className="brand" style={{ color: 'inherit', textDecoration: 'none' }}>
        <span className="brand-mark">A</span> AutoDM
      </Link>
      <div className="actions">
        <Link className="btn" to="/login">
          Log in
        </Link>
        <Link className="btn btn-primary" to="/signup">
          Start free trial
        </Link>
      </div>
    </nav>
  );
}

/** LEG-05: one footer for the landing and the legal pages, linking every legal page. */
export function PublicFooter() {
  return (
    <footer className="landing-footer">
      <div>
        <div className="brand">
          <span className="brand-mark">A</span> AutoDM
        </div>
        <p className="muted small" style={{ margin: '6px 0 0' }}>
          © {new Date().getFullYear()} {OPERATOR}. All rights reserved.
        </p>
      </div>
      <nav className="actions" aria-label="Legal and product links">
        <Link to="/login">Log in</Link>
        <Link to="/signup">Start free trial</Link>
        <a href="/v1/openapi.json" target="_blank" rel="noreferrer">
          API document
        </a>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/data-deletion">Data Deletion</Link>
        <Link to="/contact">Contact</Link>
      </nav>
    </footer>
  );
}

/** LEG-05: the short legal row under the login and signup forms. */
export function LegalLinks() {
  return (
    <p className="muted small legal-links">
      <Link to="/privacy">Privacy Policy</Link> · <Link to="/terms">Terms of Service</Link>
    </p>
  );
}

export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="landing">
      <PublicNav />
      {children}
      <PublicFooter />
    </div>
  );
}
